<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
      <div class="card-header text-center" style="background-color: #be0c4d;">
        <h4 style="color: white;">Calendario Financiación de Vivienda</h4>
      </div>
      <div class="card-body">
        <div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
          <div class="d-grid d-md-block">
            <button type="button" class="btn btn-secondary" (click)="regresarCalendario()">Volver</button>
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#nuevoAnio">+ Año</button>
          </div>
        </div>
        <br>
        <div class="container-fluid overflow-scroll">
          <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
             id="table2excel">
              <thead>
                <tr>
                  <th scope="col" class="text-center" colspan="3">Periodo</th>
                  <th scope="col" class="text-center" colspan="2">Procesamiento de Información del Periodo</th>
                  <th scope="col" class="text-center" colspan="2">Etapa de Reoclección</th>
                  <th scope="col" class="text-center" rowspan="2">Editar</th>
                </tr>
                <tr>
                  <th scope="col" class="text-center">Descripción</th>
                  <th scope="col" class="text-center">Desde</th>
                  <th scope="col" class="text-center">Hasta</th>
                  <th scope="col" class="text-center">Desde</th>
                  <th scope="col" class="text-center">Hasta</th>
                  <th scope="col" class="text-center">Inicio</th>
                  <th scope="col" class="text-center">Fin</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let periodo of PeriodosCalendario">
                  <td scope="col" >{{periodo.anio}} - {{periodo.consecutivoPeriodo}} {{periodo.descripcionPeriodo}}</td>
                  <td scope="col" >{{periodo.fechaInicioPeriodo}}</td>
                  <td scope="col" >{{periodo.fechaFinPeriodo}}</td>
                  <td scope="col" >{{periodo.fechaInicioProcesamiento}}</td>
                  <td scope="col" >{{periodo.fechaFinProcesamiento}}</td>
                  <td scope="col" >{{periodo.fechaInicioRecoleccion}}</td>
                  <td scope="col" >{{periodo.fechaFinRecoleccion}}</td>
                  <td scope="col" class="text-center" id="opciones">
                    <div class="container">
                      <div class="row">
                        <div class="col-1">
                          <a type="button" class="fa fa-edit" data-toggle="modal" data-target="#editarPeriodo" (click)="EditarPeriodo(periodo)" style="color: green;"></a>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
</body>

<!--Nuevo año-->
<div class="modal fade bd-example-modal-lg" id="nuevoAnio" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">FIVI - CREAR AÑO</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="container-fluid">
            <div class="row">
              <div class="col-3">
                <label><b>Indique año a crear: </b></label>
              </div>
              <div class="col-2">
                <select class="form-select" aria-label="Default select example" name="anios" [formControl]="nuevoAnio">
                  <option value="" selected>Seleccionar</option>
                  <option value="{{Anio}}">{{ Anio }}</option>
                </select>
              </div>
              <div class="col-4">
                <label><b>Ingrese el valor del SMMLV para el año: </b></label>
              </div>
              <div class="col-3">
                <input class="form-control" name="salariominimo" [formControl]="nuevoSalarioMin" oninput="this.value = this.value.replace(/[^0-9]/g, '')"/>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col">
                <label><b>Seleccione periodicidad: </b></label>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col-auto">Mensual</div>
                  <div class="col-auto"><input class="form-check-input" type="checkbox" value="false" name="mensual" [disabled]="mendis" [(ngModel)]="mensual" (change)="SeleccionPeriodicidad()"></div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col-auto">Trimestral</div>
                  <div class="col-auto"><input class="form-check-input" type="checkbox" value="false" name="trimestral" [disabled]="tridis" [(ngModel)]="trimestral" (change)="SeleccionPeriodicidad()"></div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closeModalCrearAnio data-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="crearVigencia()" [disabled]="btnGuardarVigencia">Guardar</button>
      </div>
    </div>
  </div>
</div>

<!--Editar periodo-->
<div class="modal fade bd-example-modal-xl" id="editarPeriodo" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
<div class="modal-dialog modal-xl">
  <div class="modal-content">
    <div class="modal-header" style="background-color: #be0c4d;">
      <h4 style="color: white;">FIVI - EDITAR PERIODO</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="container-fluid">
          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="col">
                  <label><b>Descripción periodo</b></label>
                  <input class="form-control" type="text" name="periodo" [(ngModel)]="DescripPeriEdit" disabled/>
                </div>
                <div class="col">
                  <label><b>Salario mínimo mensual legal vigente</b></label>
                  <input class="form-control" name="salariominedit" [disabled]="PermitEditPRhasta" [(ngModel)]="SalaEdit"/>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <label><b>Analisis información periodo</b></label>
              </div>
              <div class="row">
                <div class="col-2">
                  <label>Desde </label>
                </div>
                <div class="col-4">
                  <input class="form-control" type="date" name="padesde" [(ngModel)]="PAdesde" disabled/>
                </div>
                <div class="col-2">
                  <label>Hasta </label>
                </div>
                <div class="col-4">
                  <input class="form-control" type="date" name="pahasta" [(ngModel)]="PAhasta" disabled/>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-6">
              <div class="row">
                <label><b>Procesamiento información</b></label>
              </div>
              <div class="row">
                <div class="col-2">
                  <label>Desde </label>
                </div>
                <div class="col-4">
                  <input class="form-control" type="date" name="ppdesde" [(ngModel)]="PPdesde" disabled/>
                </div>
                <div class="col-2">
                  <label>Hasta </label>
                </div>
                <div class="col-4">
                  <input class="form-control" type="date" name="pphasta" [(ngModel)]="PPhasta" disabled/>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <label><b>Periodo recolección</b></label>
              </div>
              <div class="row">
                <div class="col-2">
                  <label>Inicio </label>
                </div>
                <div class="col-4">
                  <input class="form-control" type="date" name="PRdesde" [(ngModel)]="PRdesde" [disabled]="PermitEditPRdesde"/>
                </div>
                <div class="col-2">
                  <label>Fin </label>
                </div>
                <div class="col-4">
                  <input class="form-control" type="date" name="PRhasta" [(ngModel)] ="PRhasta" [disabled]="PermitEditPRhasta"/>
                </div>
              </div>
            </div>
            <div class="col-6">
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" #closeModalEditarPeriodo data-dismiss="modal">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="GuardarPeriodoEditado()" [disabled]="PermitEditPRhasta">Actualizar</button>
    </div>
  </div>
</div>
</div>
